"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerPairsInObject = void 0;
var CollisionError_1 = require("./errors/CollisionError");
var NotFoundError_1 = require("./errors/NotFoundError");
var Registration_1 = require("./Registration");
/**
 * Push item into record object and return object representing this pushment that can be destroyed
 *
 * Warning: this utility makes mutations on base record object
 */
function registerPairsInObject(_a) {
    var base = _a.base, add = _a.add, collisionStrategy = _a.collisionStrategy;
    collisionStrategy = collisionStrategy || 'ERROR';
    var skippedKeys = [];
    var overrided = {};
    for (var _i = 0, _b = Object.entries(add); _i < _b.length; _i++) {
        var _c = _b[_i], key = _c[0], value = _c[1];
        if (base[key] !== undefined) {
            var error = new CollisionError_1.CollisionError("Key \"" + key + "\" already exists in record.");
            if (collisionStrategy === 'ERROR') {
                throw error;
            }
            else if (collisionStrategy === 'WARN') {
                console.warn(error);
            }
            else if (collisionStrategy === 'SKIP') {
                skippedKeys.push(key);
            }
            else if (collisionStrategy === 'OVERRIDE') {
                overrided[key] = base[key];
                base[key] = value;
            }
        }
        else {
            base[key] = value;
        }
    }
    return new Registration_1.Registration(function () {
        for (var _i = 0, _a = Object.keys(add); _i < _a.length; _i++) {
            var key = _a[_i];
            if (base[key] === undefined) {
                if (!skippedKeys.includes(key)) {
                    throw new NotFoundError_1.NotFoundError("Key " + key + " can not be destroyed in record.");
                }
            }
            else {
                if (collisionStrategy === 'SKIP' && skippedKeys.includes(key)) {
                }
                else if (collisionStrategy === 'OVERRIDE' && overrided[key]) {
                    base[key] = overrided[key];
                }
                else {
                    delete base[key];
                }
            }
        }
    });
}
exports.registerPairsInObject = registerPairsInObject;
//# sourceMappingURL=registerPairsInObject.js.map